export default "__VITE_ASSET__BLVAeInM__"